const statsModule = {
  firestorePath: "stats",
  firestoreRefType: "collection", // or 'doc'
  moduleName: "stats",
  statePropName: "stats",
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {},
  mutations: {},
  actions: {}
};
export default statsModule;
